import React from "react";

export const HomepageHeader = ({ title }) => {
  return <div className="mb-3 font-bold text-4xl text-gray-800">{title}</div>;
};
